// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7eacbdf8","239":"5d33a141","622":"a4ea9733"}[chunkId] + ".chunk.js";
};